define('headerSalesInboxView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'notificationCenter',
  'template!headerSalesInboxView',
  // Side-effect import: registers the `salesInbox:*` reqres handlers
  // (including salesInbox:header-count / salesInbox:filter-params). The
  // header is on every page, so we can't rely on the sales-inbox page
  // module having loaded them.
  'entities/sales_inbox'
], function (
  App,
  Module,
  Marionette,
  _,
  NotificationCenter,
  Tpl
) {
  'use strict';

  // Same cadence as the chat badge — cheap, and the on-demand refreshes
  // below keep it feeling live between ticks.
  var POLL_INTERVAL_MS = 30000;

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'header-sales-inbox-view',

    ui: {
      content: '> .content',
      countItems: '.count-items'
    },

    events: {
      'click @ui.content': 'onOpen'
    },

    initialize: function () {
      this.count = 0;
    },

    onShow: function () {
      this.subscribeToChanges();
      this.fetchCount(true);
    },

    onRender: function () {
      this.renderCount();
    },

    /**
     * Refresh on the signals that can change the count without waiting for
     * the poll:
     *   - the user re-filters on the sales-inbox screen (App event), so the
     *     badge tracks "what I'm currently looking at";
     *   - a new mail lands / is removed upstream (WS), which may add or drop
     *     an inbox item.
     * Debounced because one action can fan out several events.
     * listenTo / addListener both auto-unsubscribe when the view is destroyed.
     */
    subscribeToChanges: function () {
      var refresh = _.debounce(_.bind(function () {
        this.fetchCount(false);
      }, this), 400);

      this.listenTo(App, 'salesInbox:filtersChanged', refresh);

      var nc = NotificationCenter.getInstance();
      nc.addListener(this, NotificationCenter.events.EMAILS_GMAIL_API_MESSAGE_ADDED, refresh);
      nc.addListener(this, NotificationCenter.events.EMAILS_GMAIL_API_MESSAGE_DELETED, refresh);
      // An item classified, assigned, resolved, moved to support…
      nc.addListener(this, NotificationCenter.events.SALES_INBOX_ITEM_CHANGED, refresh);
    },

    fetchCount: function (timer) {
      if (this.isDestroyed) {
        return;
      }
      App.request('salesInbox:header-count').done(_.bind(function (count) {
        if (this.isDestroyed) {
          return;
        }
        this.count = count || 0;
        this.renderCount();
      }, this));

      if (timer) {
        setTimeout(_.bind(this.fetchCount, this, true), POLL_INTERVAL_MS);
      }
    },

    renderCount: function () {
      if (this.isDestroyed) {
        return;
      }
      this.renderBadge(this.ui.countItems, this.count);
      if (this.ui.content && this.ui.content.toggleClass) {
        this.ui.content.toggleClass('activated', this.count > 0);
      }
    },

    renderBadge: function ($el, value) {
      if (!$el || !$el.html) {
        return;
      }
      if (value > 0) {
        $el.html(value > 99 ? '99+' : value);
        $el.css('display', 'flex');
      } else {
        $el.hide();
      }
    },

    onOpen: function () {
      App.navigate('sales-inbox', { trigger: true });
    }
  });
});

